import React from "react";
import {
    FiniteListWithAsyncLoaderAbstract, ListProps
} from "shared/components/Components";
import {useMercuryContext} from "../context";

class ProductTypeFilter extends FiniteListWithAsyncLoaderAbstract {

    async fetch() {
        const { data } = await this.props.context.gpClient.get("/google-gp-v1/project/listFields/projectType");
        return data.map( ( item:any ) => {
            return {
                title: item.label,
                value: item.value
            }
        })
    }
}

export default (props:ListProps) => {
    const context = useMercuryContext();
    return <ProductTypeFilter context={context} {...props} />
}
